module.exports = __webpack_public_path__ + "img/3.4e1a500d.png";